module.exports = __webpack_public_path__ + "066f1b36e8fd075b21c1d97889cc2ad5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/class-s.png
// module id = 1697
// module chunks = 0